///States
//Represent long id of the currently selected tenant
export const CurrentTenantId = 'Current-Tenant-Id';

//Represent exteternal tenant id that is used to verify user access
export const ExternalTenantId = 'External-Tenant-Id';

export const Authorization = 'Authorization';
export const UserMgtAuthorization = 'Authorization-User-Management';

